import React from 'react'
import IconButton from './IconButton'
import ContentContentCopy from 'material-ui-legacy/svg-icons/content/content-copy'

const CloneButton = ({ icon, label, ...restProps }) => (
  <IconButton
    label={label || 'Clone'}
    icon={icon || <ContentContentCopy />}
    {...restProps}
  />
)

export default CloneButton



// WEBPACK FOOTER //
// ./src/components/UI/CloneButton.jsx